import { configureStore } from '@reduxjs/toolkit';
import userReducer from './reducers/userSlice';
import userSuccessFactorReducer from './reducers/successFactorUserSlice';
import rmPendingRequestReducer from './reducers/rmPendingRequestSlice';
import userDashboardReducer from './reducers/userDashboardSlice';
import orderDashboardReducer from './reducers/orderDashboardSlice';
import poDashboardReducer from './reducers/poDashboardSlice';
import reportsSlice from './reducers/reportsSlice';
import oboDashboardSlice from './reducers/oboDashboardSlice';
import revenueForecastReducer from './reducers/revenueForecastSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    successFactorUser: userSuccessFactorReducer,
    rmPendingRequest: rmPendingRequestReducer,
    userDashboard: userDashboardReducer,
    orderDashboard: orderDashboardReducer,
    poDashboard: poDashboardReducer,
    reports: reportsSlice,
    oboReports: oboDashboardSlice,
    revenueForecast: revenueForecastReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;


